<div class="col-md-12">
  <h3 class="">Variance Analysis Report</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />
<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
  <div class="form">
      <div class="form-group row">
          <label for="UserCai" class="col-sm-2 col-form-label">Employee Name:</label>
          <div class="col-sm-4">
            {{user.Name}}
          </div>
        </div>
        <div class="form-group row">
          <label for="SupplierNamelbl" class="col-sm-2 col-form-label">Report Type</label>
          <div class="col-sm-4">
            <select id="rptType" class="form-control" [(ngModel)]="Rpt" >
                <option value="0" selected>Variance Comment</option>
                <option value="1" >Drop Comment</option>
            </select>
          </div>
        </div>
    <div class="form-group row">
      <label for="SupplierNamelbl" class="col-sm-2 col-form-label">Supplier Name:</label>
      <div class="col-sm-4">
              <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>
       </div>
    </div>

    <div class="form-group row">
      <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
      <div class="col-sm-4">
        <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
      </div>
    </div>
    <div class="form-group row">
        <label for="Yearlbl" class="col-sm-2 col-form-label">Year:</label>
        <div class="col-sm-4">
            <select id="Yearlbl" class="form-control" [(ngModel)]="Year" >
                <option value="" selected>All</option>
                <option *ngFor="let _yrs of getYrs" [ngValue]="_yrs" >{{_yrs}}</option>
              </select>
          
        </div>
      </div>
      <div class="form-group row">
       
          <label for="Monthlbl" class="col-sm-2 col-form-label"> <input type="radio" name="1" id="rbMonth" style="margin:5px;" class="with-gap"  (click)="EnableDropDown()" checked [value]="0">Service Month:</label>
          <div class="col-sm-4">              
              <select id="Monthlbl" [disabled] = "MonthRb" class="form-control" [(ngModel)]="Month" >
                  <option value="" selected>All</option>
                  <option *ngFor="let _month of getMonths" [ngValue]="_month" >{{_month}}</option>
                </select>
          </div>            
      </div>
      <div class="form-group row">
        
        <label for="Monthlbl" class="col-sm-2 col-form-label"><input type="radio" name="1" id="rbUpdatedMonth" class="with-gap" style="margin:5px;"  (click)="EnableDropDown()" [value]="1" >Updated Month:</label>
        <div class="col-sm-4">              
            <select id="UpdatedMonthlbl" [disabled] = "UpdatedMonthRb" class="form-control" [(ngModel)]="UpdatedMonth" >
                <option value="" selected>All</option>
                <option *ngFor="let _updatedmonth of getMonths" [ngValue]="_updatedmonth" >{{_updatedmonth}}</option>
              </select>
        </div>
      </div>
    <div class="form-group row">
      <div class="col-sm-2 col-form-label"></div>
      <div class="col-sm-4">
        <button class="btn btn-primary"  (click)="getDropAmtComnt()" >Search</button>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  <div >
      <table class="table table-bordered" *ngIf="dropAmtComnt.length > 0">
          <thead>
            <tr>
                <th scope="col" >Supplier Name</th>
                <th scope="col" >Object Account</th>
                <th scope="col" >Area</th>
                <th scope="col" >Service Month</th>
                <th scope="col" >Updated Date</th>
                <th scope="col" >Created By</th> 
                <th scope="col" >Drop </th>
                <th scope="col" >Reason for Drop</th>
                <th scope="col" >Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dropcmt of dropAmtComnt |paginate: { itemsPerPage: 10, currentPage: p}">
                <td>{{dropcmt.SupName}}</td>
                <td>{{dropcmt.ObjectAccount}}</td>
                <td>{{dropcmt.Area}}</td>
                <td>{{dropcmt.Period}}</td>
                <td>{{dropcmt.CreatedDate}}</td>
                <td>{{dropcmt.CreatedBy}}</td>
                <td>{{dropcmt.DropAmt |currency}}</td>
                <td>{{dropcmt.DropComments}}</td>
                <td>{{dropcmt.Remarks}}</td>
            </tr>
          </tbody>
      </table>
            <tr>
      <pagination-controls (pageChange)="p = $event" *ngIf="dropAmtComnt.length > 0"></pagination-controls> 
      <table class="table table-bordered" *ngIf="varianceComnt.length > 0">
        <thead>
          <tr>
              <th scope="col" >Supplier Name</th>
              <th scope="col" >Object Account</th>
              <th scope="col" >Cur Month VOWD</th>
              <th scope="col" >Prev Month VOWD </th>
              <th scope="col" >Created By</th> 
              <th scope="col" >Month</th>
              <th scope="col" >Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let varcmt of varianceComnt|paginate: { itemsPerPage: 10, currentPage: p}">
              <td>{{varcmt.SupName}}</td>
              <td>{{varcmt.ObjectAccount}}</td>
              <td>{{varcmt.CurMonthVOWD|currency}}</td>
              <td>{{varcmt.PrevMonthVOWD|currency}}</td>
              <td>{{varcmt.CreatedBy}}</td>
              <td>{{varcmt.Month}}</td>
              <td>{{varcmt.Comment}}</td>
          </tr>
        </tbody>
    </table>
    <pagination-controls (pageChange)="p = $event" *ngIf="varianceComnt.length > 0"></pagination-controls> 
  </div>
  <div class="form-group row" >
      <div class="col-sm-4">
        <button (click)="ExportTOExcel()"  class="btn btn-primary">ExportTOExcel</button>
      </div>
  </div>  
  <table class="table table-bordered hidden"  id="reportGrid_all">
    <thead>
      <tr>
          <th scope="col" >Supplier Name</th>
          <th scope="col" >Object Account</th>
          <th scope="col" >Area</th>
          <th scope="col" >Service Month</th>
          <th scope="col" >Updated Date</th>
          <th scope="col" >Created By</th> 
          <th scope="col" >Drop </th>
          <th scope="col" >Reason for Drop</th>
          <th scope="col" >Remarks</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let dropcmt of dropAmtComnt ">
          <td>{{dropcmt.SupName}}</td>
          <td>{{dropcmt.ObjectAccount}}</td>
          <td>{{dropcmt.Area}}</td>
          <td>{{dropcmt.Period}}</td>
          <td>{{dropcmt.CreatedDate}}</td>
          <td>{{dropcmt.CreatedBy}}</td>
          <td>{{dropcmt.DropAmt |currency}}</td>
          <td>{{dropcmt.DropComments}}</td>
          <td>{{dropcmt.Remarks}}</td>
      </tr>
    </tbody>
</table>
<table class="table table-bordered hidden"  id="reportGrid_all_var">
  <thead>
    <tr>
        <th scope="col" >Supplier Name</th>
        <th scope="col" >Object Account</th>
        <th scope="col" >Cur Month VOWD</th>
        <th scope="col" >Prev Month VOWD </th>
        <th scope="col" >Created By</th> 
        <th scope="col" >Month</th>
        <th scope="col" >Comment</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let varcmt of varianceComnt">
        <td>{{varcmt.SupName}}</td>
        <td>{{varcmt.ObjectAccount}}</td>
        <td>{{varcmt.CurMonthVOWD|currency}}</td>
        <td>{{varcmt.PrevMonthVOWD|currency}}</td>
        <td>{{varcmt.CreatedBy}}</td>
        <td>{{varcmt.Month}}</td>
        <td>{{varcmt.Comment}}</td>
    </tr>
  </tbody>
</table>